import React, { useEffect, useMemo, useState } from 'react'
import { Button, Popover } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import CheckboxGroupFilter from 'components/Filters/FilterPanel/subcomponents/CheckboxGroupFilter'
import subbuttonStyles from 'components/Filters/FilterPanel/subcomponents/SubButtons/subbuttons.module.scss'
import isEqual from 'lodash/isEqual'
import { useTranslation } from 'react-i18next'
import styles from 'components/Filters/FilterPanel/subcomponents/CheckboxSelector/checkbox-selector.module.scss'

const CheckboxSelector = ({
  filterManager,
  hasBackdrop = false,
  handleHide = () => {},
  onApply = (value) => {
    console.log(value)
  },
  popoverConfig = {
    variant: 'popover',
    id: 'checkbox-Selector-Popover',
    breakpoints: {
      0: {
        variant: 'bottomSheet',
        hasBackdrop: true,
        showLabel: true,
      },
      960: {
        variant: 'popover',
        hasBackdrop: false,
      },
    },
  },
  value = [],
  label = '',
  name,
  icon,
  ...rest
}) => {
  const { t } = useTranslation()
  const [checked, setChecked] = useState(value)
  const { filters, configuration } = filterManager

  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()
  const popoverState = usePopupState(popoverConfig)

  useEffect(() => !isEqual(checked, value) && setChecked(value), [value])

  const applySelector = (value) => {
    onApply(value)
    popoverState.close()
  }

  const handleClose = () => {
    handleHide()
    popoverState.close()
  }

  const buttonLabel = useMemo(() => {
    const prefix = t(label) + ': '

    if (Array.isArray(filters?.[name])) {
      if (filters?.[name]?.length > 0) {
        return (
          prefix +
          filters?.[name]
            .map((val) => t(configuration[name].optionLabelPrefix + val))
            .join(', ')
        )
      }
    } else {
      if (filters?.[name] !== undefined && filters?.[name] !== '') {
        return (
          prefix + t(configuration[name]?.optionLabelPrefix + filters[name])
        )
      }
    }

    return t(label)
  }, [filters, t])

  return (
    <>
      <Button
        className={styles['button']}
        variant={'outlined'}
        size={'l'}
        {...bindTrigger(popoverState)}
        startIcon={icon}
        title={buttonLabel}
      >
        {buttonLabel}
      </Button>

      <Popover
        hasBackdrop={hasBackdrop}
        bodyClassName={subbuttonStyles['subbuttons-filter__popover-inner']}
        {...bindPopover(popoverState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handleClose}
      >
        <CheckboxGroupFilter
          {...rest}
          name={name}
          label={label}
          icon={icon}
          filterManager={filterManager}
          onApply={(val) => applySelector(val)}
          value={checked}
        />
      </Popover>
    </>
  )
}

CheckboxSelector.propTypes = {
  onApply: PropTypes.func,
  popoverConfig: PropTypes.object,
  hasBackdrop: PropTypes.bool,
  handleHide: PropTypes.func,
  value: PropTypes.array,
  filterManager: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.element,
}

export default CheckboxSelector
